import { chain } from './config';

export const USD = {
  address: '0x55d398326f99059fF775485246999027B3197955',
  decimals: 18,
  name: 'Tether USD',
  symbol: 'USDT',
} as const;

export const explorer = chain.blockExplorers.default.url;
